import Vue from 'vue';
import __vue_component__ from '../icons/Icon.vue.js';

var script = Vue.extend({
    props: {
        routeName: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
        iconClass: {
            type: String,
            required: false,
            default: 'icon-arrow_left',
        },
    },
    components: {
        Icon: __vue_component__,
    },
});

export default script;
